import './firstclasscatering/style';
import FormStructure from './firstclasscatering/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/Dev/web_inquiry/inquiry-renderer/client_forms/includes.js